<template>
    <v-dialog v-model="internalShowDialog" max-width="fit-content">
      <v-card>
        <v-card-title>
          <span class="headline">{{ selectedOptions?.name }} Container Options</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <pre>{{ formattedOptions }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>

<script>
export default {
  props: {
    value: Boolean,
    selectedOptions: Object
  },
  computed: {
    internalShowDialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formattedOptions () {
      return JSON.stringify(this.selectedOptions?.options, null, 2)
    }
  },
  methods: {
    closeDialog () {
      this.internalShowDialog = false
    }
  }
}
</script>
